import { Component, EventEmitter, forwardRef, HostListener, Input, Output, Provider } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const PASSWORD_INPUT_VALUE_ACCESSOR: Provider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => PasswordInputComponent),
  multi: true,
};

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrl: './password-input.component.scss',
  providers: [PASSWORD_INPUT_VALUE_ACCESSOR],
})
export class PasswordInputComponent implements ControlValueAccessor {
  @Input() label = 'Password';
  @Input() showCapsLockWarning = true;
  @Input() capsLockOn = false;
  @Output() capsLockState = new EventEmitter<boolean>();

  password: string = null;

  private onChange!: Function;
  private onTouched!: Function;

  @HostListener('window:keyup', ['$event'])
  capsLockEvent(event: KeyboardEvent): void {
    this.capsLockOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLockState.emit(this.capsLockOn);
  }

  writeValue(password: string) {
    this.password = password;
  }

  registerOnChange(fn: Function) {
    this.onChange = (password: string) => {
      fn(password);
    };
  }

  registerOnTouched(fn: Function) {
    this.onTouched = fn;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.password = value;
    this.onChange(value);
  }
}
